import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';
//import AssistGraphic from '../img/assist-graphic.svg';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  const questions = {
    //title: 'Question 5c: Strategies',
    type: 'single',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Personal Reflection: How do you feel when using this component when trying to assist someone?`}
        />
        <strong>
          Personal Reflection: How do you feel when using this component when trying to assist someone?
        </strong>
      </Fragment>
    ),
    result: [],
    feedback: {
      correct: '',
      incorrect: '',
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: '',
      optionText:
        'I have to be really focused and intentional when doing this.'
    },
    {
      prefix: 'B',
      result: '',
      optionText:
        'I am often able to do this but it’s a good reminder.'
    },
    {
      prefix: 'C',
      result: '',
      optionText:
        'I always do this.'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={5}
      childTitle="Assist"
      progressType="assist"
    >
      <section>
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="3. Listen Actively" />
              <h2 className="txt-green no-bold no-margin">
                3. Listen actively
              </h2>
            </Col>
          </Row>
        </div>
      </section>
      <section className="no-bottom-padding">
        <div className="container">
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="Be present. Try to listen carefully and without judgment. Reflect back what you think you have heard to make sure the person feels that they are being understood. For example, you might say something like: “What I’m hearing is that you’re struggling with __________ and you’re worried about how it’s impacting __________.” Allow them time to clarify or confirm your understanding." />
              <p>
                Be present. Listen carefully and without judgment.
                Reflect back what you heard to make sure the
                person feels that they are being understood. For example, you
                might say something like:
              </p>
              <p className="font-italic text-center">
                “What I’m hearing is that you’re struggling with __________ and
                <br />
                you’re worried about how it’s impacting __________.”
              </p>
              <p>
                Allow them time to clarify or confirm your understanding.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="assist"
        categoary="survey"
        showLetter={false}
        nextRoute={url.ASSIST_F}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistE = connect.role(AssistPage);

export default AssistE;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistE/index.jsx